import { Component, EventEmitter, Inject, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GenericModal } from 'src/app/interface/data.interface';

@Component({
  selector: 'common-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['../../../library/modals/modal_confirmation.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ConfirmationModalComponent implements OnInit {
  @Input() title: string;
  @Input() subtitle: string;
  @Input() note: string;
  @Input() size: 'small' | 'large' = 'large'; // Default es large

  @Input() labelButtonCancel: string;
  @Input() labelButtonSave: string;

  @Output() success = new EventEmitter();
  @Output() denied = new EventEmitter();


  constructor(
    private matDialogRef: MatDialogRef<ConfirmationModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: GenericModal,
  ) {
    if (this.data && this.data.title) {
      this.title = this.data.title;
    }
    if (this.data && this.data.subtitle) {
      this.subtitle = this.data.subtitle;
    }
    if (this.data && this.data.note) {
      this.note = this.data.note;
    }
    if (this.data && this.data.labelButtonCancel) {
      this.labelButtonCancel = this.data.labelButtonCancel;
    }
    if (this.data && this.data.labelButtonSave) {
      this.labelButtonSave = this.data.labelButtonSave;
    }
    if (this.data && this.data.size) {
      this.size = this.data.size;
    }
  }

  ngOnInit(): void {
  }

  onEventCancel(event: boolean) {
    this.matDialogRef.close(event);
  }

  onEventSave(event: boolean) {
    this.matDialogRef.close(event);
  }

  get modalPanelClass(): string {
    return ConfirmationModalComponent.getModalPanelClass(this.size, !!this.subtitle);
  }

  static getModalPanelClass(size: 'small' | 'large' = 'large', hasSubtitle: boolean = false): string {
    if (size === 'small') {
      return hasSubtitle ? 'container__confirmation-dialog-small-with-subtitle' : 'container__confirmation-dialog-small';
    } else {
      return hasSubtitle ? 'container__confirmation-dialog-with-subtitle' : 'container__confirmation-dialog';
    }
  }

}
